import { InputCurrency, InputText } from "@sellar-io/components";
import { UseFormReturn } from "react-hook-form";
import { PriceTierFormValues } from "../../../priceTiers/priceTier/PriceTierForm";
import { InputLabel, InputContainer } from "@sellar-io/components";

export const OrderRulesForm = ({
  form,
  formId,
  onSave,
}: {
  form: UseFormReturn<PriceTierFormValues>;
  formId: string;
  onSave: (data: PriceTierFormValues) => void;
}) => {
  const register = form.register;

  return (
    <form
      className={"flex flex-col gap-2"}
      id={formId}
      onSubmit={form.handleSubmit(onSave)}
    >
      <div className="flex flex-col gap-1">
        <InputLabel>Name</InputLabel>
        <InputContainer>
          <InputText {...register("name", { required: true })} />
        </InputContainer>
      </div>
      <div className="flex flex-col gap-1">
        <InputLabel>Minimum order value</InputLabel>
        <InputContainer>
          <InputCurrency
            showPrefix
            allowNegative
            {...register("minimumOrderPrice", { required: false })}
          />
        </InputContainer>
        <span className="text-zinc-500">
          You can leave this blank if you just want to include container rules
        </span>
      </div>
    </form>
  );
};
